import { mdiHome, mdiOfficeBuilding } from "@mdi/js"
import {
  buildViewNavigation,
  type PageTabWithId,
  type ViewPageSnippets,
  type ViewPageSpec,
} from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
import type { PermissionState } from "@kontextwerk/control-web-frame/shared/logic/authorization"

type PropertiesViewFrameContext = {
  permissions: PermissionState
}

export type PropertyDetailViewPaths = {
  general: string
  units: string
  contactRouting: string
}

export const buildPropertyDetailViewPaths = (basePath: string): PropertyDetailViewPaths =>
  basePath
    ? {
        general: `${basePath}/general`,
        units: `${basePath}/units`,
        contactRouting: `${basePath}/appointment-contacts`,
      }
    : {
        general: "",
        units: "",
        contactRouting: "",
      }

const getGeneralTabs = (_ctx: PropertiesViewFrameContext): PageTabWithId[] => [
  { id: "general", title: "Allgemein" },
]

const getUnitsTabs = (_ctx: PropertiesViewFrameContext): PageTabWithId[] => [
  { id: "units", title: "Einheiten" },
]

const PAGE_SPECS: Array<ViewPageSpec<PropertiesViewFrameContext, PropertyDetailViewPaths>> = [
  {
    id: "general",
    title: "Allgemein",
    icon: mdiHome,
    resolvePath: (paths) => paths.general,
    getTabs: getGeneralTabs,
  },
  {
    id: "units",
    title: "Einheiten",
    icon: mdiOfficeBuilding,
    resolvePath: (paths) => paths.units,
    getTabs: getUnitsTabs,
  },
]

export const buildPropertyDetailViewNavigation = ({
  context,
  paths,
  snippets,
}: {
  context: PropertiesViewFrameContext
  paths: PropertyDetailViewPaths
  snippets: ViewPageSnippets
}) =>
  buildViewNavigation({
    specs: PAGE_SPECS,
    context,
    paths,
    capabilities: null,
    snippets,
  })
